import request from './utils';
import * as ROUTES from 'src/api/routes';

export interface IntegrationMigrationInfo {
    completedAt: string | null;
    surveysMigrated: number;
    templateName: string | null;
}

export interface IntegrationConfig {
    workspaceId: string | null;
    maskedApiKey: string | null;
    routingEnabled: boolean;
    workspaceName: string | null;
    lastVerified: boolean;
    migrationInfo: IntegrationMigrationInfo | null;
}

export interface UpdateApiKeyResult {
    success: boolean;
    validated: boolean;
    maskedKey: string | null;
}

export interface TestConnectionResult {
    valid: boolean;
    workspaceName: string | null;
    message: string;
}

export interface UpdateRoutingResult {
    enabled: boolean;
    message: string;
}

export async function getConfig(): Promise<IntegrationConfig> {
    const response = await request({ ...ROUTES.GET_SURVEY_INTEGRATION_CONFIG });
    return response.data.result ?? response.data;
}

export async function updateApiKey(apiKey: string): Promise<UpdateApiKeyResult> {
    const response = await request({ ...ROUTES.UPDATE_SURVEY_INTEGRATION_API_KEY, data: { apiKey } });
    return response.data.result ?? response.data;
}

export async function testConnection(): Promise<TestConnectionResult> {
    const response = await request({ ...ROUTES.TEST_SURVEY_INTEGRATION_CONNECTION });
    return response.data.result ?? response.data;
}

export async function updateRouting(enabled: boolean): Promise<UpdateRoutingResult> {
    const response = await request({ ...ROUTES.UPDATE_SURVEY_INTEGRATION_ROUTING, data: { enabled } });
    return response.data.result ?? response.data;
}
